<template>
  <div class="ht-container ht-container-admin pb-5">
    <h5>Coming Soon</h5>
    <p>
      Once available, you will be able to add additional functionality to your hometender household.
    </p>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class Addons extends Vue {

}
export default Addons;
</script>

<style scoped>

</style>
